<app-grid
  gridCssClass="tab-grid-no-summary"
  stateKey="RoleDocuments"
  [columnDefs]="columnDefs"
  [rowData]="rowData$ | async"
  [showDelete]="false"
  [pagination]="false"
  (save)="save()"
>
</app-grid>
